import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const IMPRESSUM = [
    { h: "Betreiberin", p: ["Fjona Gerber"] },
    { h: "Kontakt", p: ["E-Mail: fjona.gerber@hotmail.com"], mail: true },
    {
        h: "Haftungsausschluss",
        p: ["Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden."],
    },
    {
        h: "Urheberrecht",
        p: ["Alle Inhalte dieser Website sind urheberrechtlich geschützt. Verwendete Bilder stammen aus lizenzfreien Quellen."],
    },
];

const DATENSCHUTZ = [
    {
        h: "",
        p: ["Der Schutz deiner persönlichen Daten ist mir wichtig. Diese Datenschutzerklärung informiert darüber, wie Personendaten im Zusammenhang mit dieser Website bearbeitet werden. Es gilt das Schweizer Datenschutzrecht, insbesondere das Bundesgesetz über den Datenschutz (DSG)."],
    },
    {
        h: "1. Verantwortliche Person",
        p: ["Verantwortlich für die Datenbearbeitung ist:", "Fjona Gerber", "E-Mail: fjona.gerber@hotmail.com"],
        mail: true,
    },
    {
        h: "2. Kontaktaufnahme",
        p: [
            "Wenn du mich über das Kontaktformular oder per E-Mail kontaktierst, bearbeite ich die von dir übermittelten Angaben, insbesondere Name, Kontaktdaten und Inhalt deiner Nachricht, um deine Anfrage zu beantworten und gegebenenfalls eine Beratung zu vereinbaren.",
            "Bitte übermittle über das Kontaktformular keine ausführlichen Angaben zu Diagnosen, deiner Gesundheit, Suizidalität oder anderen besonders sensiblen persönlichen Umständen. Für eine erste Kontaktaufnahme genügt eine kurze Beschreibung deines Anliegens.",
        ],
    },
    {
        h: "3. Beratung",
        p: ["Kommt eine Beratung zustande, können weitere Personendaten bearbeitet werden, soweit dies für die Durchführung der Beratung erforderlich ist. Je nach Beratungsinhalt können darunter auch besonders schützenswerte Personendaten, insbesondere Gesundheitsdaten, fallen. Solche Informationen werden vertraulich behandelt."],
    },
    {
        h: "4. Website und Hosting",
        p: ["Diese Website wurde mit Emergent erstellt und wird über eine technische Hosting-Infrastruktur bereitgestellt. Beim Besuch der Website können technisch notwendige Daten wie IP-Adresse, Datum und Uhrzeit des Zugriffs, Browser- und Geräteinformationen sowie aufgerufene Seiten verarbeitet werden. Diese Daten dienen insbesondere dem sicheren und zuverlässigen Betrieb der Website."],
    },
    {
        h: "5. Weitergabe und Bearbeitung im Ausland",
        p: ["Personendaten können an technische Dienstleister weitergegeben werden, soweit dies für den Betrieb der Website oder die Erbringung meiner Leistungen erforderlich ist. Dabei können Personendaten auch ausserhalb der Schweiz bearbeitet werden. Soweit erforderlich, werden die gesetzlichen Voraussetzungen für eine solche Datenübermittlung berücksichtigt."],
    },
    {
        h: "6. Speicherdauer und Datensicherheit",
        p: ["Personendaten werden nur so lange aufbewahrt, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Es werden angemessene technische und organisatorische Massnahmen getroffen, um Personendaten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen."],
    },
    {
        h: "7. Deine Rechte",
        p: ["Du kannst im Rahmen des geltenden Datenschutzrechts insbesondere Auskunft über die zu deiner Person bearbeiteten Daten sowie deren Berichtigung oder Löschung verlangen. Anfragen zum Datenschutz kannst du an fjona.gerber@hotmail.com richten."],
        mail: true,
    },
    {
        h: "8. Änderungen",
        p: ["Diese Datenschutzerklärung kann angepasst werden, wenn sich die Website, die verwendeten Dienste oder die gesetzlichen Anforderungen ändern."],
        note: "Stand: September 2026",
    },
];

const CONTENT = {
    impressum: { title: "Impressum", sections: IMPRESSUM },
    datenschutz: { title: "Datenschutzerklärung", sections: DATENSCHUTZ },
};

const withMail = (text) =>
    text.split("fjona.gerber@hotmail.com").reduce((acc, part, i, arr) => {
        acc.push(part);
        if (i < arr.length - 1) {
            acc.push(
                <a key={i} href="mailto:fjona.gerber@hotmail.com" className="underline underline-offset-2 hover:text-[#2B2825]">
                    fjona.gerber@hotmail.com
                </a>
            );
        }
        return acc;
    }, []);

export const LegalDialog = ({ type, onClose }) => {
    const data = type ? CONTENT[type] : null;
    return (
        <Dialog open={!!type} onOpenChange={(o) => !o && onClose()}>
            <DialogContent
                data-testid={`legal-dialog-${type || "none"}`}
                className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#F4F1EA] border-[#DDD6C8] text-[#59534C] rounded-none p-8 sm:p-12"
            >
                {data && (
                    <>
                        <DialogHeader className="text-left">
                            <DialogTitle className="font-serif font-light text-3xl sm:text-4xl tracking-tight text-[#2B2825]">
                                {data.title}
                            </DialogTitle>
                            <DialogDescription className="sr-only">{data.title}</DialogDescription>
                        </DialogHeader>
                        <div className="mt-6 space-y-7 font-sans text-sm sm:text-base font-light leading-relaxed">
                            {data.sections.map((s) => (
                                <div key={s.h || "intro"}>
                                    {s.h && (
                                        <h3 className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#8C8275] mb-2">
                                            {s.h}
                                        </h3>
                                    )}
                                    {s.p.map((t, j) => (
                                        <p key={t.slice(0, 40)} className={`text-[#2B2825] ${j > 0 && !s.mail ? "mt-3" : ""}`}>{s.mail ? withMail(t) : t}</p>
                                    ))}
                                    {s.note && (
                                        <p className="mt-3 inline-block text-xs text-[#8C8275] bg-[#EFECE4] px-3 py-1.5">{s.note}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};
